import { Component, OnInit } from '@angular/core';
import { DocumentService } from '../../../../services/document.service';
import { CommonService } from '../../../../services/common.service';
import { Router, ActivatedRoute, ParamMap } from "@angular/router";
import { AuthenticationService } from '../../../../services/authentication.service';

@Component({
    selector: 'app-upload-document',
    templateUrl: './upload-document.component.html',
    styleUrls: ['./upload-document.component.scss']
})
export class UploadDocumentComponent implements OnInit {

    pagecode: string = "gistec-document";
    module: string = "gistec";
    accessdenied: boolean = false;

    folders: any[];
    documentTypes: any[];

    hasExpiryDate: boolean = false;
    expiryDate: Date = new Date();
    ccAddLoading: boolean = false;
    ccDeleteLoading: boolean = false;

    newFollowerEmail: string = "";

    btnVerifyDisabled: boolean = false;
    btnVerifyText: string = "Upload document";

    uploadDocument: any = {
        filename: "",
        contentbase64: "",
        contentType: "",
        size: "",
        folderId: 0,
        typeId: 0,
        description: "",
        hasExpiryDate: false,
        expiryDate: "",
        shareTo: [],
        createdUserId: this.authentication._authentication.id
    }

    upload() {
        //validation
        debugger;
        this.uploadDocument.folderId = this.SelectedFolder.id;
        this.uploadDocument.typeId = this.SelectedType.id;
        this.uploadDocument.filename = this.selectedFile.name;
        this.uploadDocument.contentType = this.selectedFile.type;
        this.uploadDocument.size = this.selectedFile.size;
        this.uploadDocument.hasExpiryDate = this.hasExpiryDate;
        this.uploadDocument.expiryDate = "";
        if (this.hasExpiryDate) {
            this.uploadDocument.expiryDate = this.expiryDate;
        }
        this.uploadDocument.shareTo = this.Followers;


        this.btnVerifyDisabled = true;
        this.documentService.uploadDocument(this.uploadDocument).subscribe(
            (res: any) => {
                //console.log("res", res);
                this.btnVerifyDisabled = false;
                if (res) {
                    this.common.ShowMessage("info", "The document is uploaded successfully. Thank you", "");
                    this._router.navigate(['/gistec/document/detail/' + res.data]);
                }
            },
            (err: any) => {
                console.error("err", err);
                this.btnVerifyDisabled = false;
            }
        );


    }
    getFile(file: any) {

        var reader = new FileReader();
        let _self = this;
        reader.onload = function (readerEvt) {
            
            var binaryString = readerEvt['target']!['result']!.toString();
            //var binaryString = "";
            var contentType = file.type;
            if (file.name.toLowerCase().indexOf(".zip") !== -1 && file.type === "") {
                contentType = "application/x-zip-compressed";
                _self.uploadDocument.contentType = contentType;
            }
            _self.uploadDocument.contentbase64 = binaryString;
        };
        reader.readAsDataURL(file);
    }
    Followers: any[] = [];
    addFollowers(email: any) {
        if (!this.common.ValidateEmail(email).valid) {
            this.common.ShowMessage('info', 'invalid email address [' + email + ']', '');
            return;
        }

        var isexisting = this.Followers.find(s => s.email.toLowerCase() == email.toLowerCase());
        if (isexisting) {
            this.common.ShowMessage('info', 'The email is already exists in the list', '');
        }
        else {
            this.ccAddLoading = true;
            this.documentService.isPortalUser(email).subscribe(
                (res: any) => {
                    console.log("this.addFollowers", res);
                    if (res.success) {
                        if (res.data != null) {
                            this.Followers.push({
                                id: res.data.id,
                                name: res.data.firstName + ' ' + res.data.lastName,
                                email: res.data.eMail,
                                contactLogo: res.data.contactLogo,
                                organization: res.data.portalAccount.name
                            });

                        }
                        else {
                            this.Followers.push({
                                name: "Unknown user",
                                email: email,
                                contactLogo: "assets/images/avatar.png",
                                organization: "",
                                id: null
                            });
                        }
                        this.newFollowerEmail = "";
                        this.ccAddLoading = false;
                    }
                    else {
                        console.error("Web/gistec/documents/addFollowers()", res.error_message);
                    }
                },
                (err: any) => {
                    this.ccAddLoading = false;
                    console.error("addFollowers()", err);
                }
            );
        }




        
        
    }
    deleteFollower(index: any) {
        this.Followers.splice(index, 1);
    }
    constructor(private route: ActivatedRoute, private _router: Router, private documentService: DocumentService, private authentication: AuthenticationService, private common: CommonService) {

        this.route.params.subscribe(val => {
            this.authentication.checkUserPageAccess(this.authentication._authentication.id, this.pagecode).subscribe(
                (res: any) => {
                    if (res.success && res.data) {


                        var pageURL = this._router.routerState.snapshot.url;
                        this.authentication.addUserPageView(pageURL, this.pagecode, this.module);

                        // load page data
                        this.getDocumentCenterFolders();
                        this.getDocumentTypes();
                        //
                    }
                    else
                        this.accessdenied = true;
                },
                (err: any) => {
                    console.error("checkUserPageAccess", err);
                    this.accessdenied = true;
                }
            );
        });

    }
    
    ngOnInit(): void {
    }

    getDocumentCenterFolders() {
        this.documentService.getDocumentCenterFolders().subscribe(
            (res: any) => {
                if (res.success) {
                    this.folders = res.data;
                    this.SelectedFolder = res.data[0];
                }
                else {
                    console.error("Web/gistec/documents/getDocumentCenterFolders()", res.error_message);
                }

            },
            (err: any) => {
                console.error("Web/gistec/documents/getDocumentCenterFolders()", err);
            }
        );
    }
    SelectedFolder: any = '';
    selectFolderOption(evt: any) {

        var optionValue = evt.target.value;
        var item = this.folders.find(s => s.id == optionValue);
        this.SelectedFolder = item;
        
    }


    getDocumentTypes() {
        this.documentService.getDocumentTypes().subscribe(
            (res: any) => {
                if (res.success) {
                    this.documentTypes = res.data;
                    this.SelectedType = res.data[0];
                }
                else {
                    console.error("Web/gistec/documents/getDocumentCenterFolders()", res.error_message);
                }
            },
            (err: any) => {
                console.error("Web/gistec/documents/getDocumentCenterFolders()", err);
            }
        );
    }
    SelectedType: any = '';
    selectTypeOption(evt: any) {

        var optionValue = evt.target.value;
        var item = this.documentTypes.find(s => s.id == optionValue);
        this.SelectedType = item;
        
    }
    selectedFile: any = { name: "", size_mb: "" };
    filesSelect(selectedFiles: any): void {
        debugger;
        if (selectedFiles.target.files.length == 1) {
            this.selectedFile = selectedFiles.target.files[0];
            var size_mb = this.selectedFile.size / 1024 / 1024;
            this.selectedFile.size_mb = parseFloat(size_mb.toString()).toFixed(2);
            this.getFile(this.selectedFile);
        }
    }

}
